<template>
  <div class="main">
    <ul id="scrollLoadContent" style="padding: 15px">
      <h4 class="BigTitle">返利卡说明</h4>

      <p class="MidTitle">山西复盛公健康药业有限公司是专业从事药品贸易、供应链金融服务的公司，旗下运营的   药百万    平台（以下简称为“本平台”）是专门为平台商户在药品贸易中，提供融资信息服务的服务网络平台。本声明包含本平台的使用条款，请您在浏览和使用本平台之前，务必仔细阅读。您在浏览和使用本平台的同时，视为您接受以下条款。山西复盛公健康药业有限公司在法律许可的范围内享有对本声明进行解释、修订及变更的权利：</p>
      <p class="SmallTitle">
        1、需知：在使用飞贷支付时，平台不会收取用户利息，用户还款从飞贷产生的利息，平台会将这部分利息以优惠券反馈给每个用户；
      </p>
      <p class="SmallTitle">
        2、返利卡：返利卡是平台将利息以优惠券形式反馈给每个用户的一种功能，用户可在【我的】、【飞贷】、【我的返利卡】、【提取息费】，输入自己想提取的息费金额，则会生成等金额的无门槛优惠券；
      </p>
      <p class="SmallTitle">
        3、优惠券：优惠券使用无门槛，例如：生成50元优惠券，则订单金额超过50元，即可享受减50元；
      </p>
      <p class="SmallTitle">
        4、生成优惠券后不使用会放在【我的】、【优惠券】中，可随时查看；
      </p>
      <p class="SmallTitle">
        5、优惠券有效期为一年；
      </p>
       <p class="SmallTitle red">注意：</p>
      <p class="SmallTitle red">
        1、返利卡是需要每年在平台有一次成功的交易才可完成激活，激活后每年12月31日失效；返利卡没有激活的用户是不可以兑换优惠券；
      </p>
       <p class="SmallTitle red">
        2、息费一旦生成优惠券，不可再退还成息费。
      </p>
    </ul>

    
  </div>
</template>
<style scoped>
.red{
    color: #ff3333!important;
}
.main {
    font-family: cursive;
  /* font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; */
  line-height: 1.42857143;
  background-color: #fff;
}
.BigTitle {
  text-align: center;
  font-size: 0.17rem;
  font-weight: bold;
  color: #2e2e32;
  margin-bottom: 0.07rem;
}
.MidTitle {
  text-indent: 0.26rem;
  font-size: 0.13rem;
  font-weight: bold;
  color: #2e2e32;
  margin-top: 0.1rem;
  margin-bottom: 0.1rem;
  text-align: left;
}
.SmallTitle {
    text-indent: 0.24rem;
  font-size: 0.12rem;
  font-weight: bold;
  color: #2e2e32;
  text-align: left;
  line-height: 0.2rem;
}
.msg {
  font-size: 0.12rem;
  color: #636366;
  text-align: left;
  line-height: 0.2rem;
}
</style>
<script>
export default {
    name: 'RebateDes',
     created() {
    },
  }


</script>



// WEBPACK FOOTER //
// src/components/RebateDes.vue